import { get, set } from "./schedule.js";
function durationFunction(id, value) {
    return function () {
        set(this, id).duration = +value.apply(this, arguments);
    };
}
function durationConstant(id, value) {
    return value = +value, function () {
        set(this, id).duration = value;
    };
}
export default function (value) {
    var id = this._id;
    return arguments.length
        ? this.each((typeof value === "function"
            ? durationFunction
            : durationConstant)(id, value))
        : get(this.node(), id).duration;
}
